<template>
  <div class="character-detail">
    <Navigator @setting="setting"/>
    <div class="detail-wrap" v-if="Object.keys(character).length">
      <div class="info">
        <img :src="character.avatar" @error="setDefaultAvatar" class="avatar" alt="" />
        <p class="name">{{ character.name }}</p>
        <p class="desc">{{ character.description }}</p>
        <TagList :list="character.tags" />
      </div>
      <div class="detail">
        <div class="nav">
          <span v-for="(item, index) in navList" :key="index" :class="['nav-item', {'active': index === activeIdx }]">{{ item }}</span>
        </div>
        <div class="content">
          <template v-if="selfies.length">
            <div class="content-item" v-for="item in selfies" :key="item.id">
              <img :src="item.url" alt="" @click="handleSelfiesClick(item)" />
            </div>
          </template>
          <Empty v-else-if="loaded"/>
        </div>
      </div>
    </div>
    <ImageDisplay v-if="showPreivew" :imgInfo="imgInfo" @close="handleClose" @setChatBg="setChatBg"/>
  </div>
</template>
<script>
import { getCharacterById, getSelfies } from '@/api';
import chatSession from '@/utils/chatSession';
import defaultAvatarImage from '@/assets/images/icon/avatar.png';
import Empty from '@/components/Empty.vue';
import TagList from '@/components/TagList.vue';
import Navigator from './components/Navigator';
import ImageDisplay from './components/ImageDisplay';

export default {
  components: {
    Navigator,
    TagList,
    ImageDisplay,
    Empty,
  },
  data() {
    return {
      character: {},
      characterId: '',
      navList: ['Selfies'],
      activeIdx: 0,
      selfies: [],
      imgInfo: {},
      showPreivew: false,
      loaded: false,
    };
  },
  created() {
    this.init();
  },
  methods: {
    setDefaultAvatar(e) {
      e.target.src = defaultAvatarImage;
    },
    setting() {
    },
    init() {
      this.getCharacter();
      this.getSelfies();
    },
    async getCharacter() {
      const loading = this.$loading();
      const { params: { characterId: id } } = this.$route || {};
      if (!id) return;
      this.characterId = id;
      const res = await getCharacterById(id);
      if (res.code !== 0) return;
      this.character = res?.data?.character || {};
      loading.close();
    },
    async getSelfies() {
      const res = await getSelfies(this.characterId);
      if (res.code !== 0) return;
      this.selfies = res?.data?.selfies || [];
      this.loaded = true;
    },
    handleSelfiesClick(item) {
      this.imgInfo = item;
      this.showPreivew = true;
    },
    handleClose() {
      this.showPreivew = false;
      this.imgInfo = {};
    },
    setChatBg(info) {
      if (!info.url) return;
      chatSession.updateChatBg(this.characterId, info.url);
      this.$toast.success('operation successful!');
      this.handleClose();
    },
  },
};
</script>
<style lang="less" scoped>
.character-detail {
  height: 100vh;
  display: flex;
  flex-direction: column;
  .detail-wrap {
    flex: 1;
    display: flex;
    flex-direction: column;
    padding: 0 16px;
    .info {
      display: flex;
      flex-direction: column;
      align-items: center;
      .avatar {
        width: 90px;
        height: 90px;
        flex-shrink: 0;
        border-radius: 90px;
        margin: 16px 0;
      }
      .name {
        font-size: @fontLarge;
        font-weight: 600;
      }
      .desc {
        color: rgba(30, 30, 30, 1);
        padding: 16px 0;
      }
    }
    .nav {
      padding: 33px 0;
      .nav-item {
        color: rgba(117, 117, 117, 1);
        font-size: 15px;
        &.active {
          color: rgba(59, 220, 188, 1);
          font-weight: 600;
          position: relative;
          display: inline-flex;
          flex-direction: column;
          &::after {
            content: '';
            width: 19px;
            height: 4px;
            border-radius: 6px;
            background: rgba(59, 220, 188, 1);
            align-self: center;
          }
        }
      }
    }
    .content {
      display: flex;
      flex-wrap: wrap;
      .content-item {
        width: 98px;
        height: 134px;
        border-radius: 8px;
        margin-bottom: 16px;
        overflow: hidden;
        &:nth-child(3n-1) {
          margin: 0 17px;
        }
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
}
</style>
